import { cn, Status, StatusColor, type TestableComponent } from "@quortex/front-common"
import type { FC } from "react"

enum CdnStatusSize {
  SMALL = "small",
  MEDIUM = "medium"
}
type CdnStatusSizeType = `${CdnStatusSize}`

const statusToColor = {
  ERROR: StatusColor.DISABLED,
  HEALTHY: StatusColor.ACTIVE,
  NO_DATA: StatusColor.DISABLED,
  READY: StatusColor.INFO,
  WARNING: StatusColor.WARNING
} as const

interface CdnStatusProps extends TestableComponent {
  qoEStatus: api.switchns.Cdn["qoeStatus"]
  className?: string
  size?: CdnStatusSizeType
}

const CdnStatus: FC<CdnStatusProps> = ({ qoEStatus, className, size = CdnStatusSize.SMALL }) => {
  return (
    <div className={cn("flex text-sm", className)} data-testid="cdn-status">
      {qoEStatus && qoEStatus !== "DISABLED" && (
        <Status className="first-letter:uppercase" color={statusToColor[qoEStatus]}>
          <div
            className={cn(
              size === CdnStatusSize.SMALL ? "typo-sm-regular" : "typo-base-regular",
              "lowercase first-letter:uppercase"
            )}
          >
            {qoEStatus.replace("_", " ")}
          </div>
        </Status>
      )}
    </div>
  )
}

export default CdnStatus
